export default "/images/vendor/flag-icons/flags/1x1/gb-sct.svg?5e8518f9c48a90941d024e7c190a661e";